import { gql } from "@apollo/client";

export const REGISTER_RO = gql`
mutation RegisterRO($input: RegisterFranchiseInput) {
  registerRO(input: $input) {
    username
    _id
  }
}
`